import React from 'react';
import PlazaMain from './pages/PlazaMain';

function App() {
  return (
    <div className="App">
      <PlazaMain />
    </div>
  );
}

export default App;
